import { injectable } from "inversify";
import HumanAgentRepository from "../../repositories/human_agent.repository";
import { Either, isLeft } from "fp-ts/lib/Either";
import HumanAgentEntity from "../../entities/human_agent.entity";
import ErrorEntity from "../../entities/error.entity";

interface Props {
    humanAgentRepository: HumanAgentRepository;
}

@injectable()
class DownladAllHumanAgentsUseCase {
    private humanAgentRepository: HumanAgentRepository;

    constructor({ humanAgentRepository }: Props) {
        this.humanAgentRepository = humanAgentRepository;
    }

    public call = async (): Promise<Either<ErrorEntity, void>> => {
        return this.humanAgentRepository.downloadAllAsCsv();
    }
}

export default DownladAllHumanAgentsUseCase;

export const DownladAllHumanAgentsUseCaseName = "DownladAllHumanAgentsUseCase";